import React from 'react';

const fenneq = {
    intro: {
        title: 'FENNEQ',
        subTitle: 'One Platform. Many Industries.',
    },
    subIntro: {
        leftAligned: true,
        children: (
            <>
                <p>Transform complex business problems into optimized solutions. No PhD required. No mathematical modeling. No quantum expertise. Upload your data, describe your constraints, and our platform does the rest.</p>
            </>
        ),
    },
    divider: {},
    subIntro1: {
        children: (
            <>
                <h2>How It Works</h2>
            </>
        ),
    },
    cardsGroup: {
        children: [
            {
                icon: 'icon-cloud-upload',
                title: '1. Data Ingestion',
                card: "Upload historical data in any format — CSV, JSON, Excel, database connections, API integrations.",
            },
            {
                icon: 'icon-comment-text',
                title: '2. Problem Description',
                card: "Describe your optimization challenge. What are you minimizing or maximizing? What are your constraints?",
            },
            {
                icon: 'icon-chart-line',
                title: '3. Predictive Modeling',
                card: "FENNEQ builds ML models from your data to forecast what your optimization depends on — demand, flows, failures.",
            },
            {
                icon: 'icon-code',
                title: '4. Automatic Formulation',
                card: "Your problem is mapped to the right mathematical model — QUBO, constraint satisfaction, linear programming, or custom.",
            },
            {
                icon: 'icon-lightning',
                title: '5. Intelligent Solving',
                card: "Our solver layer picks the best approach — quantum annealing, hybrid solvers, reinforcement learning, or classical optimizers. It learns which works best for your problem class.",
            },
        ],
    },
    divider1: {},
    subIntro2: {
        children: (
            <>
                <h2>Problem Types We Solve</h2>
            </>
        ),
    },
    cardsGroup1: {
        children: [
            {
                icon: 'icon-calendar-dates',
                title: 'Scheduling & Allocation',
                card: "Aircraft stands, crew scheduling, resource assignment, shift planning — assigning limited resources to competing demands.",
            },
            {
                icon: 'icon-route',
                title: 'Routing & Logistics',
                card: "Vehicle routing, delivery optimization, supply chain flows — finding the best routes through complex constraints.",
            },
            {
                icon: 'icon-sliders-horiz',
                title: 'Configuration & Planning',
                card: "Frequency planning, network configuration, portfolio optimization — selecting from vast possibility spaces.",
            },
            {
                icon: 'icon-crosshair',
                title: 'Prediction & Classification',
                card: "Demand forecasting, anomaly detection, pattern recognition — ML insights integrated with optimization.",
            },
        ],
    },
    divider2: {},
    subIntro3: {
        children: (
            <>
                <h2>Deployment Options</h2>
            </>
        ),
    },
    cardsGroup2: {
        children: [
            {
                icon: 'icon-cloud',
                title: 'Qamia Cloud',
                card: "Managed service with regional data residency. We handle the infrastructure.",
            },
            {
                icon: 'icon-server',
                title: 'Private Cloud',
                card: "Deployment in your cloud environment. Your infrastructure, our platform.",
            },
            {
                icon: 'icon-home-2',
                title: 'On-Premise',
                card: "Full installation within your infrastructure. Complete control.",
            },
        ],
    },
    divider3: {},
    quote: {
        children: (
            <>
                See FENNEQ in action across telecommunications, aviation, and energy.
            </>
        ),
        cta: {
            url: '/use-cases/',
            children: 'View Use Cases',
        },
    },
};

export default fenneq;
